import React from 'react'
import { QuestionTypeEnum } from 'packages/sdks-next/growp'
import { EditProductQuestionItemProps } from '../../types'
import { EditSubChoiceAnswer } from './EditSubChoiceAnswer'
import { EditSubShortAnswer } from './EditSubShortAnswer'
import { EditFullInBlankAnswer } from './EditSubFullInBlankAnswer'

export const EditProductAnswer: React.FC<
  EditProductQuestionItemProps & {
    type: QuestionTypeEnum
  }
> = (props) => {
  const { type } = props
  switch (type) {
    case QuestionTypeEnum.SingleChoice:
    case QuestionTypeEnum.MultipleChoice: {
      return <EditSubChoiceAnswer {...props} />
    }
    case QuestionTypeEnum.ShortAnswer: {
      return <EditSubShortAnswer {...props} />
    }
    case QuestionTypeEnum.FillInBlank: {
      return <EditFullInBlankAnswer {...props} />
    }
    default:
      return <div>未知题型</div>
  }
}
